import Hora from './Hora'
import Carousel, { consts }  from 'react-elastic-carousel'
import Item from './Item'


function Htmlhora({ locality, hour_hour, copyright }) {
            //<div className="header" ><h2>El tiempo por horas en {locality.name} </h2><p>Próximas 24 horas | Datos de Tutiempo.net</p></div>

    return (
        <>
                  <div className="header"><p>Próximas 24 horas | {copyright}</p></div>
 
       
            <Carousel itemPosition={consts.START} pagination={false} showArrows={false} breakPoints={[
        { width: 1, itemsToShow: 2, itemsToScroll: 2 },
        { width: 190, itemsToShow: 3 , itemsToScroll: 3},
        { width: 400, itemsToShow: 5 , itemsToScroll: 5},
        { width: 550, itemsToShow: 6 , itemsToScroll: 6},
        { width: 700, itemsToShow: 7 , itemsToScroll: 7},
        { width: 1000, itemsToShow: 8 , itemsToScroll: 8},
        { width: 1200, itemsToShow: 9 , itemsToScroll: 9},
        { width: 1750, itemsToShow: 10 , itemsToScroll: 10}
      ]} >
                <Item><Hora {...hour_hour.hour1} /></Item>
                <Item><Hora {...hour_hour.hour2} /></Item>
                <Item><Hora {...hour_hour.hour3} /></Item>
                <Item><Hora {...hour_hour.hour4} /></Item>
                <Item><Hora {...hour_hour.hour5} /></Item>
                <Item><Hora {...hour_hour.hour6} /></Item>
                <Item><Hora {...hour_hour.hour7} /></Item>
                <Item><Hora {...hour_hour.hour8} /></Item>
                <Item><Hora {...hour_hour.hour9} /></Item>
                <Item><Hora {...hour_hour.hour10} /></Item>
                <Item><Hora {...hour_hour.hour11} /></Item>
                <Item><Hora {...hour_hour.hour12} /></Item>
                <Item><Hora {...hour_hour.hour13} /></Item>
                <Item><Hora {...hour_hour.hour14} /></Item>
                <Item><Hora {...hour_hour.hour15} /></Item>
                <Item><Hora {...hour_hour.hour16} /></Item>
                <Item><Hora {...hour_hour.hour17} /></Item>
                <Item><Hora {...hour_hour.hour18} /></Item>
                <Item><Hora {...hour_hour.hour19} /></Item>
                <Item><Hora {...hour_hour.hour20} /></Item>
                <Item><Hora {...hour_hour.hour21} /></Item>
                <Item><Hora {...hour_hour.hour22} /></Item>
                <Item><Hora {...hour_hour.hour23} /></Item>
                <Item><Hora {...hour_hour.hour24} /></Item>
                <Item><Hora {...hour_hour.hour25} /></Item>
            </Carousel>
            <div><p className="linkTT"><a href={locality.url_hourly_forecast} target="_blank" rel="noreferrer"
                >Ver pronóstico por horas 14 días</a></p></div>
        </>
    )
}
export default Htmlhora;